<div class="axis-block">
  <h3>{{ title }}</h3>

  @if (!hideInputSelectors) {
    <div class="input-type-row">
      <mat-form-field style="width: 10rem">
        <mat-label>Input type</mat-label>
        <mat-select [(ngModel)]="inputType" (ngModelChange)="onInputTypeChange()">
          <mat-option value="Question">Question</mat-option>
          <mat-option value="Calculation">Calculation</mat-option>
          <mat-option value="Formula" [disabled]="!(cc.formulas | async)?.length">Formula</mat-option>
        </mat-select>
      </mat-form-field>

      @if (inputType === "Calculation") {
        <app-key-select [value]="axis.keyId" (change)="setKeyId($event)"></app-key-select>
      }

      @if (inputType === "Question") {
        <mat-form-field style="width: 28rem">
          <mat-label>Question</mat-label>
          <mat-select [(ngModel)]="axis.keyId" (ngModelChange)="onQuestionSelected($event)">
            @for (q of qs.draftQuestions | async; track q.id) {
              <mat-option [value]="q.id">{{ q.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (inputType === "Formula") {
        <mat-form-field style="width: 28rem">
          <mat-label>Formula</mat-label>
          <mat-select [(ngModel)]="axis.formulaId" (ngModelChange)="onFormulaSelected($event)">
            @for (f of cc.formulas | async; track f.formulaId) {
              <mat-option [value]="f.formulaId">{{ f.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  }

  @if (hasAxisInputSource) {
    @if (isLookupAxis) {
      <p class="axis-lookup-hint">Bands use this question's choice codes. Row or column count matches the number of choices (same idea as a 1D lookup table).</p>
      @if (lookupBandRows.length > 0) {
        <ul class="axis-lookup-list">
          @for (row of lookupBandRows; track row.value) {
            <li>
              <span class="axis-lookup-label">{{ row.label }}</span> — <code>{{ row.value }}</code>
            </li>
          }
        </ul>
      } @else {
        <p class="axis-lookup-empty">This question has no choices yet. Add choices on the question, then reselect it if needed.</p>
      }
    } @else if (axis.breakpoints) {
      <div class="numeric-axis-bands">
        <div class="breakpoint-values-grid">
          <mat-form-field appearance="outline" class="breakpoint-count-field">
            <mat-label>Number of breakpoints</mat-label>
            <input matInput type="number" min="1" [max]="maxBreakpointBands" [value]="axis.breakpoints.length" (input)="onBreakpointCountInput($event)" />
          </mat-form-field>
          @for (b of axis.breakpoints; track $index; let i = $index) {
            <mat-form-field appearance="outline" class="breakpoint-floor-field">
              <mat-label>Floor {{ i + 1 }}</mat-label>
              <input matInput type="number" [(ngModel)]="axis.breakpoints[i]" (ngModelChange)="emitStructureChange()" />
            </mat-form-field>
          }
        </div>
      </div>
    }
  } @else if (!hideInputSelectors) {
    <p class="axis-pick-input-hint">Choose an input above to set bands for this axis.</p>
  }
</div>
